import {AuthorizeEsiaResponsePayload} from '../../../../shared/models/api/authorizeEsiaResponsePayload';
import {RegisterClientCabinetRequestPayload} from '../../../../shared/models/api/registerClientCabinetRequestPayload';
import {EsiaResponseType} from '../../../../shared/models/login';
import {Sex} from '../../../../shared/models/profile/sex';
import {formatPhone, formatSnils, onlyDigitsPipe} from '../../../../shared/pipes';
import {KidSaturated, ParentSaturated} from '../esiaRegCardState/model';
import {EsiaRegCardForm, KidSubform} from './form/model';

export const mapEsiaRegInfoToFormValues = (
  regInfo: Partial<
    AuthorizeEsiaResponsePayload & {
      isEmailNotificationEnabled: boolean;
      isSmsNotificationEnabled: boolean;
      isAccountLinkingEnabled: boolean;
    }
  >,
): EsiaRegCardForm => ({
  firstName: regInfo.firstName ?? '',
  lastName: regInfo.lastName ?? '',
  middleName: regInfo.middleName ?? '',
  birthDate: regInfo.birthDate ?? '',
  birthPlace: regInfo.birthPlace ?? '',
  sex: regInfo.gender ?? Sex.male,
  address: regInfo.address ?? '',
  mobilePhone: formatPhone(regInfo.mobilePhone ?? '').replace('+7', '8'),
  email: regInfo.email ?? '',
  number: regInfo.num ?? '',
  date: regInfo.issueDate ?? '',
  codeOrg: regInfo.issueId ?? '',
  org: (regInfo.issuedBy ?? '').replace('выдан', '').trim(),
  addressReg: regInfo.addressReg ?? '',
  snils: formatSnils(onlyDigitsPipe(regInfo.snils ?? '')),
  isEmailNotificationEnabled: regInfo.isEmailNotificationEnabled ?? true,
  isSmsNotificationEnabled: regInfo.isSmsNotificationEnabled ?? true,
  isAccountLinkingEnabled: regInfo.isAccountLinkingEnabled ?? true,
});
export const mapFormValuesToEsiaRegInfo = (
  formData: Partial<EsiaRegCardForm>,
  accessToken: string | null,
): AuthorizeEsiaResponsePayload => ({
  firstName: formData.firstName ?? '',
  lastName: formData.lastName ?? '',
  middleName: formData.middleName ?? '',
  birthDate: formData.birthDate ?? '',
  birthPlace: formData.birthPlace ?? '',
  gender: formData.sex ?? Sex.male,
  address: formData.address ?? '',
  mobilePhone: formatPhone(formData.mobilePhone ?? '').replace('8', '+7'),
  email: formData.email ?? '',
  num: formData.number ?? '',
  issueDate: formData.date ?? '',
  issueId: formData.codeOrg ?? '',
  issuedBy: formData.org?.trim() ?? '',
  addressReg: formData.addressReg ?? '',
  snils: formatSnils(onlyDigitsPipe(formData.snils ?? '')),
  type: EsiaResponseType.Registration,
  token: accessToken,
  isEmailNotificationEnabled: formData.isEmailNotificationEnabled ?? true,
  isSmsNotificationEnabled: formData.isSmsNotificationEnabled ?? true,
  kids: [],
});

export const mapFormValuesToEsiaRegData = (
  formData: EsiaRegCardForm | KidSubform,
  accessToken?: string | null,
): RegisterClientCabinetRequestPayload => ({
  accessToken,
  ...formData,
  email: formData.email || null,
  mobilePhone: formData.mobilePhone ? onlyDigitsPipe(formData.mobilePhone) : null,
  addressReg: formData.addressReg || null,
  snils: onlyDigitsPipe(formData.snils),
});

export const mapUseRegCardStateKidToFormValues = (parent: ParentSaturated, kid: KidSaturated): KidSubform => {
  return {
    firstName: kid.firstName ?? '',
    lastName: kid.lastName ?? '',
    middleName: kid.middleName ?? '',
    birthDate: kid.birthDate ?? '',
    birthPlace: kid.birthPlace ?? '',
    sex: kid.gender ?? Sex.male,
    address: parent.address ?? '',
    mobilePhone: formatPhone(kid.mobilePhone ?? '').replace('+7', '8'),
    email: kid.email ?? '',
    number: `${kid.documentSeries ?? ''}${kid.documentNumber}` ?? '',
    date: kid.documentIssueDate ?? '',
    org: (kid.documentIssuedBy ?? '').replace('выдан', '').trim(),
    addressReg: parent.address ?? '',
    snils: formatSnils(onlyDigitsPipe(kid.snils ?? '')),
  };
};
